const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts[1].split(';').shift();
};
const initializeArticleDetail = () => {

    const article = document.querySelector('.news-single .article');
    const articleDetails = document.querySelector('.news-single .articleDetails');
    
    const initializePrevNextArrows = () => {
        const
            articleUid = parseInt(article.dataset.articleUid, 10),
            articleSequenceJson = getCookie("articleSequence_" + document.querySelector('html').getAttribute('lang').split('-')[0]),
            articleDetailsArrowContainer = articleDetails.querySelectorAll(".articleDetails__aside");

            if(articleDetailsArrowContainer.length > 0) {
                for(let i = 0; i < articleDetailsArrowContainer.length; i++) {
                    let container = articleDetailsArrowContainer[i];

                    if(articleUid && articleSequenceJson && container) {

                        const articleSequence = JSON.parse(articleSequenceJson);

                        const currentArticleIndex = articleSequence.indexOf(articleUid);
                        let newsDemand = {};
                        if(currentArticleIndex -1 >= 0) {
                            newsDemand['left'] = articleSequence[currentArticleIndex -1];
                        }
                        if(currentArticleIndex +1 < articleSequence.length ) {
                            newsDemand['right'] = articleSequence[currentArticleIndex +1];
                        }

                        if(Object.keys(newsDemand).length > 0) {

                            const newsDemandJsonString = JSON.stringify(newsDemand);

                            fetch(`/?search-news=${newsDemandJsonString}`)
                                .then(function (response) {
                                    return response.json()
                                })
                                .then(function (json) {
                                    if(json.left) generateArrow("left", json.left, container);
                                    if(json.right) generateArrow("right", json.right, container);
                                })
                                .catch(function (err) {
                                    console.warn('Something went wrong.', err);
                                });
                        }
                    }
                }
            }
    };

    const generateArrow = (direction, news, arrowContainer) => {

        const prevOrNext = (direction === "right") ? "next" : "previous";
        const navigationTitleLabel = arrowContainer.dataset[prevOrNext + "Label"];
        const articleTitleLabel = news.title;
        const linkTitle = arrowContainer.dataset.titleLabel.replace("%s", news.title);

        let arrow = document.createElement("span");
        arrow.classList.add(`articleDetails__aside--${direction}`);

        let arrowLink = document.createElement("a");
        arrowLink.classList.add(`${prevOrNext}Article`);
        arrowLink.href = `${arrowContainer.dataset.newsDetailUri}/${news.path_segment}`;
        arrowLink.title = linkTitle;

        arrowLink.innerHTML =
            '<span class="arrow"></span>' +
            `<span class="navigationTitle">${navigationTitleLabel}</span>` +
            `<span class="articleTitle">${articleTitleLabel}</span>`;

        arrow.appendChild(arrowLink);
        arrowContainer.appendChild(arrow);
    };
    
    if(article) {
        initializePrevNextArrows();
    }
};

initializeArticleDetail();